import { userService } from "@/app/api/user";
import type {
  ClientFitCandidateArtifactExportRequest,
  ClientFitCandidateArtifactExportResponse,
} from "@/types/client-fit";

export const exportClientFitCandidateArtifacts = async (
  request: ClientFitCandidateArtifactExportRequest,
): Promise<ClientFitCandidateArtifactExportResponse> => {
  try {
    const response =
      await userService.axiosWithUserAuth.post<ClientFitCandidateArtifactExportResponse>(
        "/client-fit/candidate-artifact-export",
        request,
      );

    return response.data;
  } catch (error) {
    console.error("Error exporting Client Fit candidate artifacts:", error);
    throw error;
  }
};
